import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { PageChartSkeleton, PageContainer, Spacer } from 'src/common';
import Meta from 'src/components/Meta';
import { useGaEventPageView } from 'src/utils/gaEvent';
import styled from 'styled-components';
import { Charts } from './comps/charts';
import { Sheet } from './comps/sheets';
import { AssessmentVersion } from 'src/api/types';
import useVersions from '../useVersions';
import { useCompareScenariosQuery } from 'src/graphql/_generated';

const SheetsWrapper = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  grid-gap: 6px;
`;

const CompareScenario = () => {
  const { scenarioAId, scenarioBId } = useParams<{
    scenarioAId: string;
    scenarioBId: string;
  }>();
  const { versionAId, versionBId } = useVersions();

  const [versionA, setVersionA] = useState<AssessmentVersion | undefined>(undefined);
  const [versionB, setVersionB] = useState<AssessmentVersion | undefined>(undefined);

  const { data: compareData, loading: isLoading } = useCompareScenariosQuery({
    variables: {
      scenarioAId: scenarioAId!,
      scenarioBId: scenarioBId!,
      versionAId,
      versionBId,
    },
  });

  useEffect(() => {
    if (compareData?.scenarioA?.assessment?.versions) {
      const version = compareData.scenarioA.assessment.versions.find((v) => v.id === versionAId);
      setVersionA(version);
    }
    if (compareData?.scenarioB?.assessment?.versions) {
      const version = compareData.scenarioB.assessment.versions.find((v) => v.id === versionBId);
      setVersionB(version);
    }
  }, [versionAId, versionBId, compareData]);

  useGaEventPageView('Cydea | Compare scenarios');

  if (isLoading || !compareData?.scenarioA || !compareData?.scenarioB)
    return (
      <PageContainer>
        <PageChartSkeleton />
      </PageContainer>
    );

  return (
    <>
      <Meta title={`Cydea | Compare Scenarios`} feedbackScript />
      <PageContainer>
        <Charts
          dataA={compareData.scenarioA}
          dataB={compareData.scenarioB}
          scenarioNameA={compareData.scenarioA.assessment.name}
          scenarioNameB={compareData.scenarioB.assessment.name}
        />
        <Spacer $px={60} />
        <SheetsWrapper>
          <Sheet
            scenario={compareData.scenarioA}
            assessmentName={compareData.scenarioA.assessment.name}
            version={versionA}
          />
          <Sheet
            scenario={compareData.scenarioB}
            assessmentName={compareData.scenarioB.assessment.name}
            version={versionB}
          />
        </SheetsWrapper>
      </PageContainer>
    </>
  );
};

export default CompareScenario;
